import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#111111] text-white px-6 md:px-12 lg:px-24 py-12">
      <div className="max-w-4xl mx-auto">
        <Button
          variant="ghost"
          className="mb-6 text-zinc-400 hover:text-white"
          onClick={() => navigate("/")}
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>

        <h1 className="text-3xl md:text-4xl font-bold mb-6">Privacy Policy</h1>
        <p className="text-zinc-400 mb-8">Last update: 29 April 2026</p>

        <div className="space-y-6 text-zinc-300 leading-7">
          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Data controller</h2>
            <p>SaaS-Radar</p>
            <p>Location: Landshut, Bayern</p>
            <p>Legal contact: saas.radar.business@gmail.com</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Data collected</h2>
            <p>We collect email addresses for account authentication and service access.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Purpose of processing</h2>
            <p>Collected data is used to provide login, secure user access, and operate the platform.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Retention</h2>
            <p>Email data is retained for up to 2 years, unless legal obligations require otherwise.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Hosting and processors</h2>
            <p>The service may rely on cloud providers such as Vercel, Render, and Supabase.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Your rights</h2>
            <p>
              You can request access, correction, or deletion of your personal data by contacting:
              {" "}saas.radar.business@gmail.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
